import { HomeIslandStatus } from 'config/constants/setting.constants';
import { CountryLocation } from 'config/types/user.type';
import { Product } from './catalog.model';

export type BannerImages = {
  desktopImage: string;
  mobileImage: string;
};

export type CountryDisplay = {
  dniLabel: string;
  dniPlaceholder: string;
  dniInvalid: string;
  phonePrefix: string;
};

export const DEFAULT_COUNTRY_DISPLAY: CountryDisplay = {
  dniLabel: 'Rut',
  dniPlaceholder: 'Ej: 11.111.111-2',
  dniInvalid: 'Rut no válido',
  phonePrefix: '+56',
};

export type HomeIsland = {
  sectionName: string;
  bannerImages: BannerImages;
  redirectUrl: string;
  isActive: boolean;
  expirationDate: string;
  expirationDateFormatted?: string;
  products: Product[];
  status: HomeIslandStatus;
  showCarousel: boolean;
  temporalEvent: string | null;
  slug: string;
  isFeatured: boolean;
  headerText: string;
  description: string;
};

export type StoreSettings = {
  isFetching: boolean;
  homeIslands: HomeIsland[];
  countryLocations: CountryLocation[];
  countryDisplay: CountryDisplay;
};
